import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { TIME_INTERVAL_TYPEWRITER } from "../constants/index";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// output 03/02/2024 03:22 PM
export const formatDateToCustomString = (date) => {
  if (!date) date = new Date();
  date = new Date(date);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formattedDate = formatter.format(date);

  return formattedDate.replace(",", "");
};

export const calculateTimeTypewriter = (maxLength) => {
  return maxLength * TIME_INTERVAL_TYPEWRITER;
};

export const randomCode = (max, min) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
};

export function generateStrongPassword(length = 10) {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const symbols = "!@#$%^&*()_+-}{[]";

  const allChars = upper + lower + numbers + symbols;

  let password = "";

  // Ensure at least one character from each category
  password += upper[Math.floor(Math.random() * upper.length)];
  password += lower[Math.floor(Math.random() * lower.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += symbols[Math.floor(Math.random() * symbols.length)];

  // Fill the remaining characters
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password to avoid predictable pattern
  password = password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return password;
}
// yyyy-mm-dd
export function formatDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function subtractDays(date = new Date(), n = 1) {
  const result = new Date(date);
  result.setDate(result.getDate() - n);
  return result;
}

export function generateCouponCode(length = 6) {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";

  const allChars = upper + lower + numbers;

  let gen = "";

  // Ensure at least one character from each category
  gen += upper[Math.floor(Math.random() * upper.length)];
  gen += lower[Math.floor(Math.random() * lower.length)];
  gen += numbers[Math.floor(Math.random() * numbers.length)];

  // Fill the remaining characters
  for (let i = gen.length; i < length; i++) {
    gen += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password to avoid predictable pattern
  gen = gen
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("")
    .toUpperCase();

  return gen;
}
